import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import MainSection from './MainSection';

const App = ({ todos, actions }) => (
  <div>
    <Header addTodo={actions.addTodo} />
    <MainSection todos={todos} actions={actions} />
  </div>
);

App.propTypes = {
  todos: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js